import React, { useState, useEffect } from 'react';
import Footer from '../../welcome/components/Footer';
import getText from '../../baseInformation/api/getText';
import type BaseInformationParams from '../../baseInformation/types/base_information_params';

type AgreementProps = {
  onAgree: () => void;
}

const Agreement: React.FC<AgreementProps> = ({ onAgree }) => {
  const [disabled, setDisabled] = useState<boolean>(true); 
  const [text, setText] = useState<string>("");
  const handleChange = () => setDisabled(!disabled);

  useEffect(() => {
    const fetchText = async () => {
      const params: BaseInformationParams = {
        type: 'agreement',
        name: 'for_facility'
      }

      try {
        const response = await getText(params);

        setText(response.data.text);
      } catch (error) {
        console.error("Error fetching terms of use data:", error);
      }
    };

    fetchText();
  }, []);

  return (
    <React.Fragment>
      <main className="wrapper">
        <div className="sec-posts">
          <div className="inner">
            <h1 className="c-ttl__01 mbpc-50 mbsp-30">ブレスオーコレクト総合サービスサイトご利用開始確認事項</h1>
            <h2 className="c-ttl__02">SEEDブレスオーコレクト総合サイト サポートセンター</h2>
            <div>
              {/* TODO: 15から36行目は、管理画面で設定した「同意事項: 施設利用開始時」を表示  */}
              <p className="c-txt__01 contact-box__txt" style={{ whiteSpace: 'pre-wrap' }}>{text}</p>
              <p className="mbpc-10 mbsp-10">
                <a href="/facility/terms_of_use" className="c-txt__02" target="_blank" rel="noopener noreferrer">ご利用規約はこちら</a>
              </p>
              <p className="mbpc-20 mbsp-20">
                <a href="/facility/privacy_policy" className="c-txt__02" target="_blank" rel="noopener noreferrer">プライバシーポリシーはこちら</a>
              </p>
              <div className="mbpc-20 mbsp-20">
                <div className="contact-box__ct">
                  <label className="checkbox-item">
                    <input type="checkbox" id="agreementCheckbox" onChange={handleChange} />
                    <span className="checkmark"></span> ご利用開始確認事項、ご利用規約、プライバシーポリシーに同意します。
                  </label>
                </div>
              </div>
              <button className="c-btn__01" id="proceedToRegistration" disabled={disabled} onClick={onAgree}>施設情報設定へ進む</button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  )
}

export default Agreement;